module.exports = __webpack_public_path__ + "img/icon_post.cba2dc7c.svg";